import sudhakar from "../assets/sudhakard.jpg";
import sabari from "../assets/sabarid.jpg";
import dhanabal from "../assets/dhanabal.jpeg";
import vishnu from "../assets/vishnuprabhu.jpg";
import arul from "../assets/arul.jpeg";
import kani from "../assets/kanid.jpg";
import thoufi from "../assets/thoufid.jpeg";
import shash from "../assets/shashd.jpeg";
import shesha from "../assets/sheshad.jpeg";

const Reviews = [
  {
    id: 1,
    name: "Sudhakar",
    bio: "Spring & Springboot",
    img: sudhakar,
    description:
      "Backend enthusiast driven by a passion for developing robust solutions. Dedicated to cultivating a positive mindset.",
  },
  {
    id: 2,
    name: "Sabarinathan",
    bio: "Front-end Developer",
    img: sabari,
    description:
      "Highly motivated and passionate B.tech Student with a expertise in HTML,CSS and JavaScript and React Js and adopting to new technologies.",
    rating: 5.0,
  },
  {
    id: 3,
    name: "Dhanabal",
    bio: "UI/UX Designer",
    img: dhanabal,
    description:
      "I'm Dhanabal, and I am a UX/UI Designer. My passion is to create a good user experience that makes people's lives easier.",
    rating: 5.0,
  },
  {
    id: 4,
    name: "Vishnu Prabhu",
    bio: "Artificial Intelligence",
    img: vishnu,
    description:
      "Embarking on the transformative journey of technology, I am passionate about fostering understanding and inspiring learners. ",
    rating: 5.0,
  },
  {
    id: 5,
    name: "Arul Selvan",
    bio: "Blockchain",
    img: arul,
    description:
      "Web3 Developer,Certified Blockchain Associate,Ambassador @EmergeX, Member @KBAIC, Blockchain Enthusiast. ",
    rating: 5.0,
  },
  {
    id: 6,
    name: "Kanishkar",
    bio: "Business & Mindset",
    img: kani,
    description:
      "Elevate your entrepreneurial spirit with our Business and Mindset Workshop. Gain valuable insights and strategies to thrive in the business world.",
    rating: 5.0,
  },
  {
    id: 7,
    name: "Sashwin",
    bio: "Cybersecurity",
    img: shash,
    description:
      "Cybersecurity enthusiast passionate about protecting digital assets and enhancing security resilience through proactive measures. ",
    rating: 5.0,
  },
  {
    id: 8,
    name: "Sheshadri",
    bio: "Express & Node js",
    img: shesha,
    description:
      "Passionate backend developer specializing in Express and Node.js, server-side applications to drive business succes. ",
    rating: 5.0,
  },
  {
    id: 9,
    name: "Syed Thoufic",
    bio: "Networking",
    img: thoufi,
    description:
      "I'm a aspiring learner about networking and wishing to bloom on the field of networking. ",
    rating: 5.0,
  },
];

export default Reviews;
